import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Breadcrumb } from '../../models/breadcrumb/breadcrumb.model';

@Component({
  selector: 'safetydirector-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnChanges {
  @Input() pageName;
  breadcrumbs: Breadcrumb[] = [];

  constructor(private router: Router) { }

  ngOnChanges(changes: SimpleChanges) {
    this.setBreadcrumbs();
  }

  private setBreadcrumbs() {
    this.breadcrumbs = [];
    this.breadcrumbs.push({ name: "Home", url: "home" });
    this.breadcrumbs.push({ name: this.pageName });
  }

  public routeTo(routeUrl: string) {
    this.router.navigate([routeUrl]);
  }
}
